import { PATHS } from '@/router/paths';
import i18n from '@/locales';
import { useConfigStore, useFnbStore, useHomeStore, useShopStore, type languageType } from '@/stores';
import { CONFIG_CONSTANTS, buildMenuFromBuildingMenus, getRequestStaffHelpFromBuildingMenus } from '@/stores/configStore';
import type { GNBItemType } from '@/types';
import type { NavigateFunction } from 'react-router-dom';

/**
 * Reset language + barrier-free settings and return to Home screensaver.
 */
export function resetKioskSessionToHomeScreensaver(navigate: NavigateFunction) {
    const { config, updateConfig } = useConfigStore.getState();
    const ui = config.ui;
    const tts = config.tts;
    const buildingMenus = config.server?.buildingMenus;
    const storeLangs = config.server?.store?.storeLangs;
    const currentLanguage =
        (storeLangs?.find((lang) => lang.main_lang)?.code as languageType) || CONFIG_CONSTANTS.DEFAULT_LANGUAGE;
    const menu: GNBItemType[] = buildMenuFromBuildingMenus(buildingMenus, currentLanguage, currentLanguage);

    void i18n.changeLanguage(currentLanguage);

    void updateConfig({
        ui: {
            ...ui,
            language: currentLanguage,
            menu,
            requestStaffHelp: getRequestStaffHelpFromBuildingMenus(buildingMenus, currentLanguage),
            zoomIn: false,
            zoomClosed: true,
            contrast: false,
            volume: 3,
            screenMode: 'fullscreen',
            zoomLevel: 1,
        },
        tts: {
            ...tts,
            voice: false,
        },
    });

    useFnbStore.getState().setKeyboardLanguage(currentLanguage === 'ko' ? 'ko' : 'en');
    useShopStore.getState().setKeyboardLanguage(currentLanguage === 'ko' ? 'ko' : 'en');
    useHomeStore.getState().resetHomeMenu();

    navigate(PATHS.HOME.INDEX, { replace: true });
}
